<template>
  <div class="loading"
       v-if="isLoading==='true'">
    <div class="loadEffect">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'loading',
  data() {
    return {
      isLoading: ''
    };
  },
  mounted() {
    const _ = this;
    window.addEventListener('setItemEvent', function(e) {
      _.isLoading = e.newValue;
    });
  }
};

</script>
<style lang="less" scoped>
* {
  padding: 0;
  margin: 0;
}
.loading {
  position: fixed;
  display: flex;
  justify-content: center;
  width: 100vw;
  background: rgba(0, 0, 0, 0.5);
  height: 100vh;
  z-index: 9;
  align-items: center;
}
.loadEffect {
  width: 50px;
  height: 50px;
  position: relative;
}
.loadEffect span {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #fd6b00;
  position: absolute;
  -webkit-animation: load 1.04s ease infinite;
  -moz-animation: load 1.04s ease infinite;
  animation: load 1.04s ease infinite;
}
@-webkit-keyframes load {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0.2;
  }
}
@keyframes load {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0.2;
  }
}
@-moz-keyframes load {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0.2;
  }
}
.loadEffect span:nth-child(1) {
  left: 0;
  top: 50%;
  margin-top: -4px;
  -webkit-animation-delay: 0.13s;
  -moz-animation-delay: 0.13s;
  animation-delay: 0.13s;
}
.loadEffect span:nth-child(2) {
  left: 7px;
  top: 7px;
  -webkit-animation-delay: 0.26s;
  -moz-animation-delay: 0.26s;
  animation-delay: 0.26s;
}
.loadEffect span:nth-child(3) {
  left: 50%;
  top: 0;
  margin-left: -4px;
  -webkit-animation-delay: 0.39s;
  -moz-animation-delay: 0.39s;
  animation-delay: 0.39s;
}
.loadEffect span:nth-child(4) {
  top: 7px;
  right: 7px;
  -webkit-animation-delay: 0.52s;
  -moz-animation-delay: 0.52s;
  animation-delay: 0.52s;
}
.loadEffect span:nth-child(5) {
  right: 0;
  top: 50%;
  margin-top: -4px;
  -webkit-animation-delay: 0.65s;
  -moz-animation-delay: 0.65s;
  animation-delay: 0.65s;
}
.loadEffect span:nth-child(6) {
  right: 7px;
  bottom: 7px;
  -webkit-animation-delay: 0.78s;
  -moz-animation-delay: 0.78s;
  animation-delay: 0.78s;
}
.loadEffect span:nth-child(7) {
  bottom: 0;
  left: 50%;
  margin-left: -4px;
  -webkit-animation-delay: 0.91s;
  -moz-animation-delay: 0.91s;
  animation-delay: 0.91s;
}
.loadEffect span:nth-child(8) {
  bottom: 7px;
  left: 7px;
  -webkit-animation-delay: 1.04s;
  -moz-animation-delay: 1.04s;
  animation-delay: 1.04s;
}
</style>



// WEBPACK FOOTER //
// src/common/components/loading.vue